import React, { Component } from "react";
import __ from "lodash";
import LoaderModal from "../../../../modal/LoaderModal";
import { CONFIG } from "../../../../../config";
import accountManagement from "../../../../../apis/accountManagement";
import "./circlebar.css";
import "./reportcbt.css";
import { Row, Col, Table } from "react-bootstrap";
import { Card, RadioGroup, FormControlLabel, Radio, CardHeader, CardContent, TableHead, TableRow, TableCell } from "@material-ui/core";
import env from "react-dotenv";

class ReportCbt extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isFetching: false,
            showIndikator: false,
            //param: this.props.location.state,
            param: this.props.match.params,
            dataMapel: [],
            data: {},
            dataLs: {},
            dataPsi: {},
            listIndikator: [],
        };
    }

    async componentDidMount() {
        document.title = "Report CBT";
        this.getReportCbt();
    }

    getReportCbt = async () => {
        this.setState({ isFetching: true });
        const { param } = this.state;
        let qString = {
            tipeCbt: param.tipeCbt,
            idJadwalCbt: param.idJadwalCbt,
            idSekolah: param.idSekolah,
            idKelas: param.idKelas,
        };
        if (param.idKelasParalel !== "null") {
            qString = { ...qString, idKelasParalel: param.idKelasParalel };
        }

        if (param.tipeCbt != "SBMPTN") {
            // ====================== !!! NON SBMPTN !!! ========================
            const response = await accountManagement
                .get(CONFIG.REPORT_CBT_GET, {
                    params: qString,
                })
                .catch(function (error) {
                    console.log(error);
                });

            if (response) {
                if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        dataMapel: response.data.data.dataMapel,
                        data: response.data.data,
                        dataLs: response.data.data.dataLs,
                        dataPsi: response.data.data.dataPsi,
                    });
                }
                this.setState({ isFetching: false });
            } else {
                this.setState({ isFetching: false });
            }
        } else {
            // ====================== !!! SBMPTN !!! ========================
            const response = await accountManagement
                .get(CONFIG.REPORT_CBT_REKAP_SBMPTN, {
                    params: qString,
                })
                .catch(function (error) {
                    console.log(error);
                });

            if (response) {
                if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        dataMapel: response.data.data.dataMapel,
                        data: response.data.data,
                        dataLs: response.data.data.dataLs,
                        dataPsi: response.data.data.dataPsi,
                    });
                }
                this.setState({ isFetching: false });
            } else {
                this.setState({ isFetching: false });
            }
        }
    };

    loadIndikator = async () => {
        this.setState({ listIndikator: [] });
        const { showIndikator, param } = this.state;

        if (showIndikator) {
            console.log("HIDE");
            this.setState({ showIndikator: !showIndikator });
        } else {
            console.log("SHOW");
            this.setState({ isFetching: true });
            let qString = {
                tipeCbt: param.tipeCbt,
                idJadwalCbt: param.idJadwalCbt,
                idSekolah: param.idSekolah,
                idKelas: param.idKelas,
            };
            if (param.idKelasParalel !== "null") {
                qString = { ...qString, idKelasParalel: param.idKelasParalel };
            }
            const response = await accountManagement
                .get(CONFIG.REPORT_CBT_LOAD_INDIKATOR, {
                    params: qString,
                })
                .catch(function (error) {
                    console.log(error);
                });

            if (response) {
                if (response.data.errorSchema.errorCode === CONFIG.SUCCESS_ERROR_CODE) {
                    this.setState({
                        listIndikator: response.data.data.data,
                        showIndikator: !showIndikator,
                    });
                }
                this.setState({ isFetching: false });
            }
        }
    };

    onPrint = () => {};

    renderIndikator(list) {
        // var temp = list[0];
        // var array = [];
        // var newObj = {};
        // var total = 0, pTuntas = 0, pTakTuntas = 0;
        // list.map(data => {
        //     if(temp.idIndikator === data.idIndikator) {
        //         total++;
        //         pTuntas += data.tuntas;
        //         pTakTuntas += data.tidakTuntas;
        //     } else {
        //         newObj = {
        //             namaIndikator: temp.namaIndikator,
        //             tuntas: Math.floor((pTuntas / total)),
        //             tidakTuntas: Math.floor((pTakTuntas /total))
        //         }
        //         array = [...array, newObj]

        //         temp = data;
        //         total = 0; pTuntas = 0; pTakTuntas = 0;

        //         total++;
        //         pTuntas += data.tuntas;
        //         pTakTuntas += data.tidakTuntas;
        //     }
        // })
        // newObj = {
        //     namaIndikator: temp.namaIndikator,
        //     tuntas: Math.floor((pTuntas / total)),
        //     tidakTuntas: Math.floor((pTakTuntas /total))
        // }
        // array = [...array, newObj]

        return (
            <tbody>
                {list.map((indi, i) => (
                    <tr>
                        <td>{indi.namaIndikator}</td>
                        <td className="text-center">{indi.tuntas}</td>
                        <td className="text-center">{indi.tidakTuntas}</td>
                    </tr>
                ))}
            </tbody>
        );
    }

    renderParentMapel() {
        if (!__.isEmpty(this.state.dataMapel)) {
            return this.state.dataMapel.map((data, i) => (
                <>
                    <Col key={i} sm={4}>
                        <Card>
                            <CardHeader title={data.namaMapel} className="box-title" style={{ marginBottom: "0 !important" }}></CardHeader>
                            <CardContent>
                                <div className="table-responsive-sm text-center">
                                    <table className="table table-sm table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th rowSpan="2" style={{ width: "40%" }}>
                                                    KATEGORI
                                                </th>
                                                <th colSpan="2" style={{ borderBottom: "none!important" }}>
                                                    JUMLAH
                                                </th>
                                            </tr>
                                            <tr>
                                                <th>SISWA</th>
                                                <th>%</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.props.match.params.tipeCbt === "SBMPTN" && (
                                                <tr>
                                                    <td>SANGAT RENDAH</td>
                                                    <td>{data.katSgtRendah}</td>
                                                    <td>{data.prosenSgtRendah}%</td>
                                                </tr>
                                            )}
                                            <tr>
                                                <td>RENDAH</td>
                                                <td>{data.katRendah}</td>
                                                <td>{data.prosenRendah}%</td>
                                            </tr>

                                            <tr>
                                                <td>SEDANG</td>
                                                <td>{data.katSedang}</td>
                                                <td>{data.prosenSedang}%</td>
                                            </tr>

                                            <tr>
                                                <td>TINGGI</td>
                                                <td>{data.katTinggi}</td>
                                                <td>{data.prosenTinggi}%</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </CardContent>
                        </Card>
                    </Col>
                    <br />
                </>
            ));
        }
    }

    render() {
        const { data, dataMapel, listIndikator, dataLs, dataPsi } = this.state;
        return (
            <div className="container-fluid" style={{ paddingBottom: "50px" }}>
                <LoaderModal isFetching={this.state.isFetching} />

                {this.state.param.tipeCbt === "AGCU" ? (
                    <img src={process.env.REACT_APP_URL_SISWA_FE + "/static/images/banner_report/Header_Report_AGCU.png"} style={{ width: "100%" }} />
                ) : (
                    <img src={process.env.REACT_APP_URL_SISWA_FE + "/static/images/agcu/report/images/HEADER_TRYOUT.jpg"} style={{ width: "100%" }} />
                )}
                <div>
                    <table className="table table-borderless">
                        <tr>
                            <td>Profil Ujian</td>
                            <td>: {data.dataProfil}</td>
                            <td>Kelas</td>
                            <td>: {data.dataKelas}</td>
                            <td>Peserta</td>
                            <td>: {data.totalPeserta}</td>
                            {this.props.match.params.tipeCbt === "SBMPTN" && <td>{this.props.match.params.idKelasParalel}</td>}
                        </tr>
                    </table>
                </div>

                {/* <div className="stat-wrapper">
                    <div className="analisis-item">
                        <h2 className="header-purple">DIAGNOSTIC TEST</h2>
                        <div className="row">
                            {dataMapel.map((data,i) =>                            
                            <div className="col-md-4 col-xs-6" key={i}>
                                <div className="box">
                                    <div className="box-body">
                                        <h4 className="box-title" style={{marginBottom:'0 !important'}}><strong>{data.namaMapel}</strong></h4>
                                        <div className="table-responsive-sm text-center">
                                            <table className="table table-sm table-striped table-hover">
                                            <thead>
                                                <tr>
                                                <th rowSpan="2" style={{width:'40%'}}>KATEGORI</th>
                                                <th colSpan="2" style={{borderBottom:'none!important'}}>JUMLAH</th>
                                                </tr>
                                                <tr>
                                                <th>SISWA</th><th>%</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    this.props.match.params.tipeCbt === 'SBMPTN' &&
                                                    <tr>
                                                        <td>SANGAT RENDAH</td>
                                                        <td>{data.katSgtRendah}</td>
                                                        <td>{data.prosenSgtRendah}%</td>
                                                    </tr>
                                                }
                                                <tr>
                                                <td>RENDAH</td>
                                                <td>{data.katRendah}</td>
                                                <td>{data.prosenRendah}%</td>
                                                </tr>

                                                <tr>
                                                <td>SEDANG</td>
                                                <td>{data.katSedang}</td>
                                                <td>{data.prosenSedang}%</td>
                                                </tr>

                                                <tr>
                                                <td>TINGGI</td>
                                                <td>{data.katTinggi}</td>
                                                <td>{data.prosenTinggi}%</td>
                                                </tr>                                                
                                            </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            )}
                        </div>
                    </div>  
                </div> */}

                <Row>{this.renderParentMapel()}</Row>

                <div className="analisis-item">
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead>
                                <th colSpan="3">
                                    <span style={{ fontSize: "1.5em" }}>Statistik Ketuntasan per Bidang Studi</span>
                                </th>
                            </thead>
                            <tbody>
                                {dataMapel.map((data, i) => (
                                    <tr>
                                        <td>{i + 1}</td>
                                        <td>
                                            {data.namaMapel}
                                            <br />
                                            <small>Jumlah Tuntas : {data.kkmTuntas}</small>
                                        </td>
                                        <td width="70%" style={{ verticalAlign: "middle!important" }}>
                                            <div className="w3-progress-container w3-round-xlarge text-center">
                                                <div className="w3-progressbar w3-round-xlarge" style={{ width: Number((data.kkmTuntas * 100) / data.total).toFixed(2) + "%" }}>
                                                    <span style={{ padding: "0 10px", fontSize: "14px" }}>{Number((data.kkmTuntas * 100) / data.total).toFixed(2)}%</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {Object.keys(dataLs).length != 0 && (
                    <div className="stat-wrapper">
                        <h2 className="header-green">LEARNING STYLE TEST</h2>
                        <div className="table-responsive">
                            <table className="table table-analisis table-ls" style={{ fontFamily: "Rubik" }}>
                                <thead>
                                    <th colSpan="2"></th>
                                    <th className="text-center" style={{ borderTopLeftRadius: "10px", borderBottomLeftRadius: "10px" }}>
                                        Jumlah Siswa
                                    </th>
                                    <th width="15%" className="text-center" style={{ borderRightWidth: "0px" }}>
                                        DOMINASI
                                    </th>
                                    <th width="24%" style={{ borderLeftWidth: "0px", borderBottomRightRadius: "10px", borderTopRightRadius: "10px" }}>
                                        {dataLs.analisa.jenisPenilaian}
                                    </th>
                                    <th></th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td width="120px">
                                            <img src="/image/reportcbt/visual.jpg" />
                                        </td>
                                        <td width="25%">VISUAL</td>
                                        <td width="15%" className="text-center">
                                            {dataLs.data.visual}
                                        </td>
                                        <td colSpan="3" style={{ verticalAlign: "middle!important" }}>
                                            <div className="w3-progress-container w3-round-xlarge text-center">
                                                <div className="w3-progressbar w3-round-xlarge" style={{ width: Number((dataLs.data.visual * 100) / data.totalPeserta).toFixed(2) + "%" }}>
                                                    <span style={{ padding: "0 10px", fontSize: "14px" }}>{Number((dataLs.data.visual * 100) / data.totalPeserta).toFixed(2)}%</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <img src="/image/reportcbt/auditori.jpg" />
                                        </td>
                                        <td width="25%">AUDITORI</td>
                                        <td width="15%" className="text-center">
                                            {dataLs.data.audi}
                                        </td>
                                        <td colSpan="3" style={{ verticalAlign: "middle!important" }}>
                                            <div className="w3-progress-container w3-round-xlarge text-center">
                                                <div className="w3-progressbar w3-round-xlarge" style={{ width: Number((dataLs.data.audi * 100) / data.totalPeserta).toFixed(2) + "%" }}>
                                                    <span style={{ padding: "0 10px", fontSize: "14px" }}>{Number((dataLs.data.audi * 100) / data.totalPeserta).toFixed(2)}%</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <img src="/image/reportcbt/kinestetik.jpg" />
                                        </td>
                                        <td width="25%">KINESTETIK</td>
                                        <td width="15%" className="text-center">
                                            {dataLs.data.kines}
                                        </td>
                                        <td colSpan="3" style={{ verticalAlign: "middle!important" }}>
                                            <div className="w3-progress-container w3-round-xlarge text-center">
                                                <div className="w3-progressbar w3-round-xlarge" style={{ width: Number((dataLs.data.kines * 100) / data.totalPeserta).toFixed(2) + "%" }}>
                                                    <span style={{ padding: "0 10px", fontSize: "14px" }}>{Number((dataLs.data.kines * 100) / data.totalPeserta).toFixed(2)}%</span>
                                                </div>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="analisis-item">
                            <div className="rounded-title text-center">
                                <strong>KARAKTERISTIK UMUM</strong>
                            </div>
                            <div className="card">
                                <div className="card-body">
                                    <div className="card-text" dangerouslySetInnerHTML={{ __html: dataLs.analisa.analisis }}></div>
                                </div>
                            </div>
                        </div>

                        <div className="analisis-item">
                            <div className="rounded-title text-center">
                                <strong>SARAN UNTUK GURU</strong>
                            </div>
                            <div className="card">
                                <div className="card-body">
                                    <div className="card-text" dangerouslySetInnerHTML={{ __html: dataLs.analisa.saranGuru }}></div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}

                {Object.keys(dataPsi).length != 0 && (
                    <div className="stat-wrapper">
                        <h2 className="header-blue">PSYCHOLOGY POTENTIAL TEST</h2>
                        <div className="table-responsive">
                            <table className="table table-analisis table-psiko" style={{ fontFamily: "Rubik" }}>
                                <thead>
                                    <th colSpan="2"></th>
                                    <th width="10%" className="text-center">
                                        RATA-RATA
                                    </th>
                                    <th>KATEGORI</th>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="text-center">
                                            <img src="/image/reportcbt/AQ.png" />
                                        </td>
                                        <td>
                                            AQ [ADVERSITY QUOTIENT]
                                            <br />
                                            <small>(Daya Juang)</small>
                                        </td>
                                        <td className="text-center">{dataPsi.skorAq}</td>
                                        <td>{dataPsi.labelAq}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="4" className="bordered" dangerouslySetInnerHTML={{ __html: dataPsi.analisaAq }}></td>
                                    </tr>

                                    <tr>
                                        <td className="text-center">
                                            <img src="/image/reportcbt/EQ.png" />
                                        </td>
                                        <td>
                                            EQ [EMOTIONAL QUOTIENT]
                                            <br />
                                            <small>(Kecerdasan Emosi)</small>
                                        </td>
                                        <td className="text-center">{dataPsi.skorEq}</td>
                                        <td>{dataPsi.labelEq}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="4" className="bordered" dangerouslySetInnerHTML={{ __html: dataPsi.analisaEq }}></td>
                                    </tr>

                                    <tr>
                                        <td className="text-center">
                                            <img src="/image/reportcbt/AM.png" />
                                        </td>
                                        <td>
                                            AM [ACHIEVEMENT MOTIVATION]
                                            <br />
                                            <small>(Motivasi Berprestasi)</small>
                                        </td>
                                        <td className="text-center">{dataPsi.skorAm}</td>
                                        <td>{dataPsi.labelAm}</td>
                                    </tr>
                                    <tr>
                                        <td colSpan="4" className="bordered" dangerouslySetInnerHTML={{ __html: dataPsi.analisaAm }}></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                <div id="btn_print">
                    {this.state.showIndikator ? (
                        <div className="fixed_button">
                            <button className="btn btn-outline-primary btn133w pull-right" onClick={() => this.loadIndikator()}>
                                Hide Indikator
                            </button>
                            <button className="btn btn-outline-dark btn133w pull-right" style={{ marginRight: "1em" }} onClick={() => window.print()}>
                                Print
                            </button>
                        </div>
                    ) : (
                        <div className="fixed_button">
                            <button className="btn btn-outline-primary btn133w pull-right" onClick={() => this.loadIndikator()}>
                                Show Indikator
                            </button>
                            <button className="btn btn-outline-dark btn133w pull-right" style={{ marginRight: "1em" }} onClick={() => window.print()}>
                                Print
                            </button>
                        </div>
                    )}
                </div>

                {Object.keys(listIndikator).length != 0 && (
                    <div className="stat-wrapper">
                        {listIndikator.map(
                            (data, i) =>
                                data.indikators.length !== 0 && (
                                    <div key={i}>
                                        <div className="header-pelajaran">
                                            <strong> {data.namaMapel} </strong>
                                        </div>
                                        <div className="table-responsive">
                                            <table className="table table-sm table-striped table-hover thead-color">
                                                <thead>
                                                    <th style={{ textAlign: "center", letterSpacing: "5px" }}>INDIKATOR</th>
                                                    <th width="15%" className="text-center">
                                                        TUNTAS
                                                    </th>
                                                    <th width="15%" className="text-center">
                                                        BELUM TUNTAS
                                                    </th>
                                                </thead>

                                                {this.renderIndikator(data.indikators)}
                                                {/* {data.indikators.map((indi, j) =>                             
                            <tr>
                                <td>{j+1}</td>
                                <td>{indi.namaIndikator}</td>
                                <td className="text-center">{indi.tuntas}</td>
                                <td className="text-center">{indi.tidakTuntas}</td>
                            </tr>
                            )} */}
                                            </table>
                                        </div>
                                    </div>
                                )
                        )}
                    </div>
                )}
            </div>
        );
    }
}

export default ReportCbt;
